/**
 * Inline SVG icon set (24×24 grid, 1.5 px strokes, square-ish terminals). No icon CDN.
 * Add icons here; keep them geometric and quiet.
 */
import type { CSSProperties } from 'react';

const P: Record<string, string> = {
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  close: 'M6 6l12 12M18 6L6 18',
  check: 'M5 12.5l4.5 4.5L19 7.5',
  'chevron-left': 'M14.5 6l-6 6 6 6',
  'chevron-right': 'M9.5 6l6 6-6 6',
  'chevron-down': 'M6 9.5l6 6 6-6',
  'chevron-up': 'M6 14.5l6-6 6 6',
  'arrow-left': 'M19 12H5M11 6l-6 6 6 6',
  'arrow-right': 'M5 12h14M13 6l6 6-6 6',
  north: 'M12 3l5 16-5-3.5L7 19z',
  crosshair: 'M12 2v5M12 17v5M2 12h5M17 12h5M12 8a4 4 0 1 1 0 8a4 4 0 1 1 0-8z',
  fit: 'M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5',
  layers: 'M12 3l9 5-9 5-9-5zM3 13l9 5 9-5M3 17.5l9 5 9-5',
  target: 'M12 3a9 9 0 1 1 0 18a9 9 0 1 1 0-18zM12 8a4 4 0 1 1 0 8a4 4 0 1 1 0-8z',
  pin: 'M12 21s-6.5-6.2-6.5-11.2a6.5 6.5 0 0 1 13 0C18.5 14.8 12 21 12 21zM12 7.5a2.3 2.3 0 1 1 0 4.6a2.3 2.3 0 1 1 0-4.6z',
  flag: 'M6 21V4M6 4h11l-2.5 4L17 12H6',
  camera: 'M3 8h3.5L8 5.5h8L17.5 8H21v11H3zM12 10.5a3.2 3.2 0 1 1 0 6.4a3.2 3.2 0 1 1 0-6.4z',
  video: 'M3 7h12v10H3zM15 10.5l6-3.5v10l-6-3.5',
  user: 'M12 4a4 4 0 1 1 0 8a4 4 0 1 1 0-8zM4 20.5c1.4-3.6 4.4-5.5 8-5.5s6.6 1.9 8 5.5',
  users: 'M9 5a3.5 3.5 0 1 1 0 7a3.5 3.5 0 1 1 0-7zM2.5 20c1.1-3.2 3.5-5 6.5-5s5.4 1.8 6.5 5M16 5.3a3.5 3.5 0 0 1 0 6.4M18 15.3c1.6.8 2.8 2.4 3.5 4.7',
  aircraft: 'M12 2.5c.9 0 1.4 1.6 1.4 3.6V9l7.6 3.8v2l-7.6-1.6v4.3l2.2 1.8v1.6L12 20l-3.6.9v-1.6l2.2-1.8v-4.3L3 14.8v-2L10.6 9V6.1c0-2 .5-3.6 1.4-3.6z',
  rotor: 'M12 9a3 3 0 1 1 0 6a3 3 0 1 1 0-6zM12 2v7M12 15v7M2 12h7M15 12h7',
  radio: 'M12 10.5a1.5 1.5 0 1 1 0 3a1.5 1.5 0 1 1 0-3zM8.1 8.1a5.5 5.5 0 0 0 0 7.8M15.9 8.1a5.5 5.5 0 0 1 0 7.8M5.3 5.3a9.5 9.5 0 0 0 0 13.4M18.7 5.3a9.5 9.5 0 0 1 0 13.4',
  play: 'M7 4.5v15l12.5-7.5z',
  pause: 'M7 5h3.5v14H7zM13.5 5H17v14h-3.5z',
  clock: 'M12 3a9 9 0 1 1 0 18a9 9 0 1 1 0-18zM12 7v5.5l3.5 2',
  timecode: 'M3 6h18v12H3zM7 10v4M11 10v4M15 10v4M9 12h.01M13 12h.01',
  film: 'M4 4h16v16H4zM8 4v16M16 4v16M4 8h4M4 12h4M4 16h4M16 8h4M16 12h4M16 16h4',
  replay: 'M4 12a8 8 0 1 0 2.4-5.7M4 4v4.5h4.5M10 9v6l5-3z',
  plan: 'M4 5l5-2 6 2 5-2v16l-5 2-6-2-5 2zM9 3v16M15 5v16',
  live: 'M12 9.5a2.5 2.5 0 1 1 0 5a2.5 2.5 0 1 1 0-5zM6.3 6.3a8 8 0 0 0 0 11.4M17.7 6.3a8 8 0 0 1 0 11.4',
  a2a: 'M4 15l5-1.5 3 3.5 1.5-1-1.8-4 4.8-1.5c1.3-.4 2-1.3 1.6-2s-1.6-.8-2.9-.4L10.5 10 6 7l-1.5.5 2.8 3.9-3.4 1z',
  media: 'M3 5h18v14H3zM10 9v6l5-3z',
  sun: 'M12 8a4 4 0 1 1 0 8a4 4 0 1 1 0-8zM12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M4.9 19.1l1.8-1.8M17.3 6.7l1.8-1.8',
  moon: 'M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z',
  wind: 'M3 9h11a3 3 0 1 0-3-3M3 15h15a3 3 0 1 1-3 3M3 12h8',
  cloud: 'M7 18h10.5a4 4 0 0 0 .5-8 6 6 0 0 0-11.5 1.5A3.3 3.3 0 0 0 7 18z',
  alert: 'M12 3.5L22 20.5H2zM12 10v4.5M12 17.5v.01',
  info: 'M12 3a9 9 0 1 1 0 18a9 9 0 1 1 0-18zM12 11v5.5M12 7.5v.01',
  bell: 'M6 16V11a6 6 0 1 1 12 0v5l1.5 2h-15zM10 20.5a2 2 0 0 0 4 0',
  'bell-off': 'M6 16V11a6 6 0 0 1 9.4-4.9M18 11v5l1.5 2H8M10 20.5a2 2 0 0 0 4 0M3 3l18 18',
  location: 'M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M12 6a6 6 0 1 1 0 12a6 6 0 1 1 0-12zM12 10a2 2 0 1 1 0 4a2 2 0 1 1 0-4z',
  'location-off': 'M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M12 6a6 6 0 1 1 0 12a6 6 0 1 1 0-12zM3 3l18 18',
  settings: 'M12 9a3 3 0 1 1 0 6a3 3 0 1 1 0-6zM19.4 13.5l1.6 1.2-2 3.4-1.9-.7a7.4 7.4 0 0 1-2 1.2L14.8 21h-4l-.3-2.4a7.4 7.4 0 0 1-2-1.2l-1.9.7-2-3.4 1.6-1.2a7.4 7.4 0 0 1 0-2.9L4.6 9.4l2-3.4 1.9.7a7.4 7.4 0 0 1 2-1.2l.3-2.4h4l.3 2.4a7.4 7.4 0 0 1 2 1.2l1.9-.7 2 3.4-1.6 1.2a7.4 7.4 0 0 1 0 2.9z',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
  'more-v': 'M12 5h.01M12 12h.01M12 19h.01',
  menu: 'M4 7h16M4 12h16M4 17h16',
  search: 'M10.5 4a6.5 6.5 0 1 1 0 13a6.5 6.5 0 1 1 0-13zM15.5 15.5L20 20',
  logout: 'M14 4h5v16h-5M10 8l-4 4 4 4M6 12h10',
  link: 'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7L11.5 6.8M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1.5-1.5',
  sim: 'M4 4h16v12H4zM8 20h8M12 16v4M10 7.5v5l4-2.5z',
  eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12zM12 9.5a2.5 2.5 0 1 1 0 5a2.5 2.5 0 1 1 0-5z',
  grid: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
  list: 'M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01',
  rings: 'M12 11a1 1 0 1 1 0 2a1 1 0 1 1 0-2zM12 7a5 5 0 1 1 0 10a5 5 0 1 1 0-10zM12 3a9 9 0 1 1 0 18a9 9 0 1 1 0-18z',
  satellite: 'M4.5 13.5l6 6M7.5 10.5l6 6-2.5 2.5-6-6zM13.5 4.5l6 6-2.5 2.5-6-6zM10.5 13.5L13 11M16 3a5 5 0 0 1 5 5',
  map: 'M4 5l5-2 6 2 5-2v16l-5 2-6-2-5 2zM9 3v16M15 5v16',
  download: 'M12 4v11M7 10.5l5 5 5-5M4 20h16',
  upload: 'M12 20V9M7 13.5l5-5 5 5M4 4h16',
  refresh: 'M20 12a8 8 0 1 1-2.3-5.7M20 4v4.5h-4.5',
  signal: 'M4 20v-3M9 20v-7M14 20V9M19 20V4',
  wifi: 'M2.5 9a14 14 0 0 1 19 0M5.5 12.5a9.5 9.5 0 0 1 13 0M8.8 16a5 5 0 0 1 6.4 0M12 19.5v.01',
  'wifi-off': 'M2.5 9a14 14 0 0 1 5-2.9M12 5.5a14 14 0 0 1 9.5 3.5M5.5 12.5a9.5 9.5 0 0 1 3.3-2M15.5 10.8a9.5 9.5 0 0 1 3 1.7M8.8 16a5 5 0 0 1 6.4 0M12 19.5v.01M3 3l18 18',
  key: 'M8 11a4 4 0 1 1 0 8a4 4 0 1 1 0-8zM11 13.5L20 5M16.5 8.5L19 11M14 11l2 2',
  copy: 'M8 8h12v12H8zM4 16V4h12',
  edit: 'M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4',
  phone: 'M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a1 1 0 0 1-1 1A16 16 0 0 1 4 5a1 1 0 0 1 1-1z',
  trash: 'M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13',
  drag: 'M9 6h.01M15 6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01',
  hand: 'M8 13V5.5a1.5 1.5 0 0 1 3 0V11M11 10V4a1.5 1.5 0 0 1 3 0v6.5M14 10V5.5a1.5 1.5 0 0 1 3 0V14c0 4-2.7 7-6.5 7-2.4 0-4-1-5.3-2.8L3 15a1.6 1.6 0 0 1 2.5-2l2.5 2.5',
  compass: 'M12 3a9 9 0 1 1 0 18a9 9 0 1 1 0-18zM15.5 8.5l-2 5-5 2 2-5z',
  'track-up': 'M12 3l6 17-6-4-6 4z',
  mark: 'M5 21V4h10l-1.8 4L15 12H5',
  record: 'M12 7a5 5 0 1 1 0 10a5 5 0 1 1 0-10z',
  archive: 'M3 4h18v4H3zM5 8v12h14V8M10 12h4',
  stop: 'M6.5 6.5h11v11h-11z',
};

export type IconName = keyof typeof P | (string & {});

export interface IconProps {
  name: IconName;
  size?: number;
  strokeWidth?: number;
  className?: string;
  style?: CSSProperties;
  /** Fill the shape instead of stroking (play, record, aircraft…). */
  filled?: boolean;
  title?: string;
}

const FILLED_BY_DEFAULT = new Set(['play', 'pause', 'aircraft', 'record', 'north', 'track-up']);

export function Icon({ name, size = 18, strokeWidth = 1.6, className, style, filled, title }: IconProps) {
  const d = P[name];
  const fill = filled ?? FILLED_BY_DEFAULT.has(name);
  const dots = name === 'more' || name === 'more-v' || name === 'drag';
  return (
    <svg
      className={className ? `icon ${className}` : 'icon'}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? 'currentColor' : 'none'}
      stroke={fill ? 'none' : 'currentColor'}
      strokeWidth={dots ? 3 : strokeWidth}
      strokeLinecap={dots ? 'round' : 'round'}
      strokeLinejoin="round"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      style={style}
    >
      {title ? <title>{title}</title> : null}
      {d ? <path d={d} /> : <rect x="5" y="5" width="14" height="14" />}
    </svg>
  );
}

/** Airview Studio: framing corners and an ascending sightline. */
export function BrandMark({ size = 24, className }: { size?: number; className?: string }) {
  // Rounded tracking brackets locked on a faceted aircraft heading 035; the shaded facet is a softer tone of the same colour.
  return (
    <svg className={className} width={size} height={size} viewBox="184 184 656 656" aria-hidden>
      <path
        d="M207 387L207 295A88 88 0 0 1 295 207L387 207M817 387L817 295A88 88 0 0 0 729 207L637 207M817 637L817 729A88 88 0 0 1 729 817L637 817M207 637L207 729A88 88 0 0 0 295 817L387 817"
        fill="none"
        stroke="currentColor"
        strokeWidth="38"
        strokeLinecap="round"
      />
      <g transform="translate(512 520) rotate(35) scale(5.4) translate(0 -6)" fill="currentColor">
        <path d="M0 -42L0 21L-33 38Z" />
        <path d="M0 -42L33 38L0 21Z" opacity="0.62" />
      </g>
    </svg>
  );
}
